import { render, staticRenderFns } from "./slaccount.vue?vue&type=template&id=1d534995&"
import script from "./slaccount.vue?vue&type=script&lang=js&"
export * from "./slaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports